import { useEffect } from "react";
import InferenceHomepage from "../components/inference/inference-homepage";

/**
 * Standalone /pricing route. Renders the full marketing landing (which already
 * contains nav + pricing section + footer) and auto-scrolls to the pricing
 * anchor on mount so users landing on /pricing directly see the pricing grid.
 */
export default function PricingPage() {
  useEffect(() => {
    // Defer to next frame so InferenceHomepage has mounted and #pricing exists
    const id = requestAnimationFrame(() => {
      const el = document.getElementById("pricing");
      if (el) el.scrollIntoView({ behavior: "auto", block: "start" });
    });
    return () => cancelAnimationFrame(id);
  }, []);

  return <InferenceHomepage />;
}
